import { render, staticRenderFns } from "./PanoramaFrame.vue?vue&type=template&id=006f6d52&scoped=true"
import script from "./PanoramaFrame.vue?vue&type=script&lang=js"
export * from "./PanoramaFrame.vue?vue&type=script&lang=js"
import style0 from "./PanoramaFrame.vue?vue&type=style&index=0&id=006f6d52&prod&scoped=true&lang=css"
import style1 from "./PanoramaFrame.vue?vue&type=style&index=1&id=006f6d52&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006f6d52",
  null
  
)

export default component.exports